module.exports = __webpack_public_path__ + "img/collaborate_58.50eb31e5.jpg";